// extracted by mini-css-extract-plugin
export default {"imagePreview":"modaladditem_imagePreview__edr6y","inputFile":"modaladditem_inputFile__xmtLb","imageIcon":"modaladditem_imageIcon__T0RS4","label":"modaladditem_label__ybGLF"};